import {home} from "./pages/home";
import {models} from "./pages/models";
import {characterProfileActions, charactersDirectory, discovery, mediaHubVideos, profileHeroVideo, toolsDirectory} from "./pages/discovery";
import {publicPages} from "./pages/public-pages";
import {pricing} from "./pages/pricing";
import {credits} from "./pages/credits";
import {creatorCampaigns} from "./pages/creator-campaigns";
import {headerNavigation} from "./components/header-navigation";
import {aiShorts} from "./pages/ai-shorts";

headerNavigation();
home();
models();
discovery();
toolsDirectory();
charactersDirectory();
profileHeroVideo();
characterProfileActions();
mediaHubVideos();
publicPages();
pricing();
credits();
creatorCampaigns();
aiShorts();
